import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-why-us',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './why-us.component.html',
  styleUrl: './why-us.component.scss'
})
export class WhyUsComponent {
  pillars = [
    {
      title: 'EXPERIENCE',
      desc: 'With more than 25 years of construction industry experience behind our leadership team, we understand what it takes to deliver a successful build.',
      icon: 'award'
    },
    {
      title: 'PERSONAL SERVICE',
      desc: 'We believe building your home should feel personal. You’ll have a team that listens, communicates and understands what matters to you.',
      icon: 'heart'
    },
    {
      title: 'TRANSPARENT COMMUNICATION',
      desc: 'Clear communication creates confidence. We keep you informed throughout your project so you know what to expect at every stage.',
      icon: 'message'
    },
    {
      title: 'QUALITY CRAFTSMANSHIP',
      desc: 'We take pride in the details. From structural workmanship to the final finishes, quality is considered at every stage.',
      icon: 'ribbon'
    },
    {
      title: 'PRACTICAL APPROACH',
      desc: 'Good building starts with good planning. We combine design ambition with practical construction knowledge to create homes that work beautifully in the real world.',
      icon: 'blueprint'
    },
    {
      title: 'YOUR HOME. YOUR WAY.',
      desc: 'We don’t believe one design fits everyone. Your home should reflect how you live, what you value and what you want for the future.',
      icon: 'compass'
    }
  ];
}
